module.exports = __webpack_public_path__ + "media/images/mobile/solutions/15-7a047bd1da960e544fbc25f0713d8771.png";